(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("dataPrivacy", {
        templateUrl: "app/settings/dataPrivacy/dataPrivacy.component.html",
        controller: ["messageService", "tenantResource", DataPrivacyCtrl],
        controllerAs: "vm"
    });
    function DataPrivacyCtrl(messageService, tenantResource) {
        var vm = this;
        vm.saving = false;
        init();
        /////////////////////////////////////////
        function init() {
            tenantResource.getDataPrivacyView(function (data) {
                vm.model = data;
            });
        }
        vm.save = function () {
            vm.saving = true;
            tenantResource.saveDataPrivacy(vm.model, function () {
                messageService.success("common.changesSaved");
                vm.saving = false;
            }, function (error) {
                messageService.error(error);
                vm.saving = false;
            });
        };
    }
})();
